//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.LoginMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.LoginMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.LoginMutationSelections
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class LoginMutation(
  public val email: Optional<String?> = Optional.Absent,
  public val password: String,
) : Mutation<LoginMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    LoginMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = LoginMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = LoginMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(LoginMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val login: Login,
  ) : Mutation.Data

  public data class Login(
    public val token: String?,
    public val refreshToken: String?,
    public val userId: Any?,
    public val failedAttemptMessage: String?,
    public val user: User?,
  )

  public data class User(
    public val username: String?,
    public val emailAddress: String,
    public val fullName: String,
    public val accesses: Accesses,
  )

  public data class Accesses(
    public val readOnly: List<String>,
    public val readWrite: List<String>,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "ffe15e627b8e52a82923ab8b3127becb78ab0e2a52293c8c8e058596f50fec15"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation login($email: String, $password: String!) {
     *   login(command: {
     *     emailAddress: $email
     *     password: $password
     *   }
     *   ) {
     *     token
     *     refreshToken
     *     userId
     *     failedAttemptMessage
     *     user {
     *       username
     *       emailAddress
     *       fullName
     *       accesses {
     *         readOnly
     *         readWrite
     *       }
     *     }
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation login(${'$'}email: String, ${'$'}password: String!) { login(command: { emailAddress: ${'$'}email password: ${'$'}password } ) { token refreshToken userId failedAttemptMessage user { username emailAddress fullName accesses { readOnly readWrite } } } }"

    public const val OPERATION_NAME: String = "login"
  }
}
